$(document).ready(function(){
  (function addTopbarLinksToMobileMenu() {
    try {
      var $allLinks = $('.site-announcement .topbar-nav-wrapper .topbar-menu-item').clone().addClass('navmenu-item');
      if ($allLinks.length > 0) {
        $allLinks.find('a.topbar-menu-link').addClass('navmenu-link');
        $allLinks.appendTo($('.mobile-nav-panel .mobile-nav-content ul'));
      }
    } catch (error) {
      console.log("Error occured in addTopbarLinksToMobileMenu() at custom.js\n", error);
    }
  })();

  (function updateProductFeatureRibbonsOnSwatches() {
    var escapeFeatureText = function(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    var isTruthy = function(value) {
      return value === true || value === 'true' || value === '1' || value === 1;
    };

    var buildFeatureRibbonHTML = function(swatchEl, ribbonsEl) {
  var hasSampling = isTruthy(ribbonsEl && ribbonsEl.dataset && ribbonsEl.dataset.featureSampling);
  var hasVisualiser = isTruthy(swatchEl && swatchEl.dataset && swatchEl.dataset.featureVisualiser);
  var badge = swatchEl && swatchEl.dataset && swatchEl.dataset.featureBadge
    ? swatchEl.dataset.featureBadge.trim()
    : '';

  var html = '';

  // Product-level ribbon - always keep it
  if (hasSampling) {
    html += '<span class="product-card-feature-ribbon product-card-feature-ribbon--sample">Samples Available</span>';
  }

  // Variant badge
  if (badge) {
    html += '<span class="product-card-feature-ribbon product-card-feature-ribbon--custom">' +
      escapeFeatureText(badge) +
      '</span>';
  }

  // Variant visualiser
  if (hasVisualiser) {
    html += '<span class="product-card-feature-ribbon product-card-feature-ribbon--visualiser">Visualizer Available</span>';
  }

  return html;
};

    var updateFeatureRibbons = function(swatchEl) {
      if (!swatchEl) return;

      var productItem = swatchEl.closest('.productitem');
      var ribbonsEl = productItem && productItem.querySelector('[data-feature-ribbons]');

      if (!ribbonsEl) return;

      var ribbonHTML = buildFeatureRibbonHTML(swatchEl, ribbonsEl);
      ribbonsEl.innerHTML = ribbonHTML;
      ribbonsEl.hidden = ribbonHTML === '';
    };

    var restoreFeatureRibbons = function(productItem) {
      if (!productItem) return;

      var activeSwatch = productItem.querySelector('.active-swatch[data-swatch]');

      if (!activeSwatch) {
        activeSwatch = productItem.querySelector('[data-swatch][data-variant-id]');
      }

      updateFeatureRibbons(activeSwatch);
    };

    $(document).on('mouseenter focusin', '.productitem [data-swatch][data-variant-id]', function() {
      updateFeatureRibbons(this);
    });

    $(document).on('mouseleave focusout', '.productitem [data-swatch][data-variant-id]', function() {
      restoreFeatureRibbons(this.closest('.productitem'));
    });

    $(document).on('click', '.productitem [data-swatch][data-variant-id]', function() {
      updateFeatureRibbons(this);
    });
  })();
});
